import { useQuery } from '@tanstack/react-query';

import { getDiscoveryService } from '../services/discoveryService';
import { useSdkManifest } from './useSdkManifest';

export function useSatellitePlaces(clientName: string) {
  const discoveryService = getDiscoveryService()!;

  const { data } = useSdkManifest(clientName);
  const etag = discoveryService?.getSdkPlacesEtag();

  return useQuery({
    staleTime: Infinity,
    queryKey: ['sdkplaces.json', clientName, etag],
    enabled: !!data,
    queryFn: async () => {
      const places = await discoveryService.getSdkPlaces();
      return places.data.filter((place: any) => {
        if (place.destination_geo) {
          return true;
        }
        return false;
      });
    },
  });
}
